module.exports = __webpack_public_path__ + "static/donate-6b4aacd832128ba27cf0c75fb2854ce7.jpeg";